import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=117e05e0&"
import script from "./AppTab.vue?vue&type=script&lang=js&"
export * from "./AppTab.vue?vue&type=script&lang=js&"
import style0 from "./AppTab.vue?vue&type=style&index=0&id=117e05e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports